document.addEventListener("DOMContentLoaded", function () {
    const settingsButton = document.querySelector('.settings-button');
    const settingsPopUp = document.querySelector('#settings-pop-up');
    const settingsBg = document.querySelector('#settings-pop-up .bg');
    const closeButton = document.querySelector('#close-settings-popup');
    const body = document.querySelector("body");
    const settingsElements = document.querySelectorAll('#settings-pop-up .content .item');
    let settingsProps = {}

    if (!settingsButton || !settingsPopUp) return;
    
    function updateTickerTapeTheme(isLight) {
        const tickerTape = document.querySelector('tv-ticker-tape');
        if (tickerTape) {
            tickerTape.setAttribute('theme', isLight ? 'light' : 'dark');
        }
    }

    _applySettings()

    function setupVariantButtons() {
        const variantContainers = settingsPopUp.querySelectorAll('.variants-container');
        variantContainers.forEach(container => {
            const variants = container.querySelectorAll('.variant');
            const buttonCount = variants.length;
            container.style.setProperty('--button-count', buttonCount);

            variants.forEach((variant, index) => {
                variant.addEventListener('click', () => {
                    variants.forEach(v => v.classList.remove('selected'));
                    variant.classList.add('selected');
                    container.style.setProperty('--selected-index', index);
                });
            });
        });
    }

    function initializePositions() {
        const themeModeContainer = settingsPopUp.querySelector('.item[data-key="theme-mode"] .variants-container');
        if (themeModeContainer) {
            const isLight = body.classList.contains('light') || body.classList.contains('cb-light');
            const index = isLight ? 1 : 0;

            themeModeContainer.querySelectorAll('.variant').forEach(v => v.classList.remove('selected'));
            themeModeContainer.querySelectorAll('.variant')[index].classList.add('selected');
            themeModeContainer.style.setProperty('--selected-index', index);
        }
        
        const qualityContainer = settingsPopUp.querySelector('.item[data-key="quality"] .variants-container');
        if (qualityContainer) {
            const isMobile = /(iPhone|iPad|iPod|Android|Mobi|Tablet)/i.test(navigator.userAgent);
            const isQuality = settingsProps.quality ? settingsProps.quality === 'quality' : !isMobile
            const index = isQuality ? 0 : 1;

            qualityContainer.querySelectorAll('.variant').forEach(v => v.classList.remove('selected'));
            qualityContainer.querySelectorAll('.variant')[index].classList.add('selected');
            qualityContainer.style.setProperty('--selected-index', index);
        }
    }

    settingsButton.addEventListener('click', () => {
        settingsPopUp.classList.add('show');
        initializePositions();

        if (window.gtag) gtag('event', `Desktop_TopNav_SettingsMenu`);
    });

    const closePopup = () => {
        settingsPopUp.classList.remove('show');
    };

    if (settingsBg) settingsBg.addEventListener('click', closePopup);
    if (closeButton) closeButton.addEventListener('click', closePopup);

    const replayTutorialBtn = document.getElementById('btn-replay-tutorial');
    if (replayTutorialBtn) {
        replayTutorialBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            closePopup();
            if (window.StockStormTutorial) {
                window.StockStormTutorial.open({ force: true, step: 0 });
            }
            if (window.gtag) gtag('event', 'Desktop_TopNav_Settings_ReplayTutorial');
        });
    }

    setupVariantButtons();

    settingsElements.forEach(element => {
        const dataKey = element.getAttribute('data-key');

        element.addEventListener('click', (e) => {
            let changedField = null;
            let changedValue = null;

            if (dataKey === 'time-zone') {
                element.classList.toggle('selected');
                const isActive = !element.classList.contains('selected');
                const stockChart = document.getElementById('stock-chart');
                if (stockChart) {
                    stockChart.setAttribute('tradingview-universal-chart', {
                        isETTimeZone: isActive
                    });
                }
                changedField = 'isETTimeZone';
                changedValue = isActive;

                if (window.gtag) gtag('event', `Desktop_TopNav_Settings_TimeZone${isActive ? 'ET' : 'Local'}`);

                try {
                    const event = new CustomEvent('timezone-changed', {
                        detail: { isETTimeZone: isActive }
                    });
                    document.dispatchEvent(event);
                    console.log('Dispatched timezone-changed event:', isActive);
                } catch (e) {
                    console.warn('Failed to dispatch timezone-changed event', e);
                }
            }


            if (dataKey === 'theme-mode') {
                const target = e.target;
                if (target.classList.contains('variant')) {
                    const value = target.innerHTML;

                    body.classList.remove('light', 'cb-light', 'cb-dark');
                    if (value === "Light" && !settingsProps.isHighContrastOn) body.classList.add('light');
                    if (value === "Light" && settingsProps.isHighContrastOn) body.classList.add('cb-light');
                    if (value !== "Light" && settingsProps.isHighContrastOn) body.classList.add('cb-dark');

                    updateTickerTapeTheme(value === "Light");

                    changedField = 'themeMode';
                    changedValue = value;

                    if (window.gtag) gtag('event', `Desktop_TopNav_Settings_${value === "Light" ? 'LightMode' : 'DarkMode'}`);
                }
            }

            if (dataKey === 'high-contrast') {
                element.classList.toggle('selected');
                const isActive = element.classList.contains('selected');
                changedField = 'isHighContrastOn';
                changedValue = isActive;

                body.classList.remove('light', 'cb-light', 'cb-dark');
                if (settingsProps.themeMode === "Light" && !isActive) body.classList.add('light');
                if (settingsProps.themeMode === "Light" && isActive) body.classList.add('cb-light');
                if (settingsProps.themeMode !== "Light" && isActive) body.classList.add('cb-dark');

                if (window.gtag) gtag('event', `Desktop_TopNav_Settings_${isActive ? 'HighContrastOn' : 'HighContrastOff'}`);
            }

            if (dataKey === 'quality') {
                const target = e.target;
                if (target.classList.contains('variant')) {
                    const value = target.innerHTML;                    

                    changedField = 'quality';
                    changedValue = value === 'Higher quality' ? 'quality' : 'performance';

                    if (window.gtag) gtag('event', `Desktop_TopNav_Settings_${value === 'Higher quality' ? 'HigherQuality' : 'FastPerformance'}`);
                }
            }
            
            _saveSettings(changedField, changedValue)
            
            if (changedField === 'quality') {
                window.location.reload();
            }
        });
    });
    
    // track switch to 3d
    const allLinks = document.querySelectorAll('#settings-pop-up a');
    allLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            if (!window.gtag) return
            
            e.preventDefault()
            const href = link.getAttribute('href');
            let eventName = 'Desktop_TopNav_Settings_';
            if (link.classList.contains('to-vr')) eventName += 'SwitchTo3D';
            if (link.textContent === 'Privacy Policy') eventName += 'PrivacyClick';
            if (link.textContent === 'Terms of Use') eventName += 'TermsOfUseClick';
            if (link.textContent === 'About Us') eventName += 'AboutUsClick';
            if (link.classList.contains('contact-us')) eventName += 'ContactClick';
            
            gtag('event', eventName, {
                event_callback: function() {
                    window.location.href = href;
                }
            });
        })
        
    })

    function _applySettings() {
        const STORAGE_KEY = 'mainSettings'
        const existing = localStorage.getItem(STORAGE_KEY);
        if (existing) {
            const payload = JSON.parse(existing)?.value;
            settingsProps = payload

            if (payload.isETTimeZone === false) {
                const timeZoneField = document.querySelector('#settings-pop-up .content .item[data-key="time-zone"]');
                if (timeZoneField) timeZoneField.classList.add('selected');
                const stockChart = document.getElementById('stock-chart');
                if (stockChart) {
                    stockChart.setAttribute('tradingview-universal-chart', { isETTimeZone: false });
                }
            }


            if (payload.themeMode === 'Light') {
                const themeField = document.querySelector('#settings-pop-up .content .item[data-key="theme-mode"]');
                if (themeField) themeField.classList.add('selected');


                if (payload.isHighContrastOn) {
                    body.classList.add('cb-light');
                } else {
                    body.classList.add('light');
                }
                updateTickerTapeTheme(true);
            } else {
                if (payload.isHighContrastOn) {
                    body.classList.add('cb-dark');
                }
                updateTickerTapeTheme(false);
            }
            if (payload.isHighContrastOn === true) {
                const highContrastField = document.querySelector('#settings-pop-up .content .item[data-key="high-contrast"]');
                highContrastField.classList.add('selected');
            }
        } else {
            const isLight = body.classList.contains('light') || body.classList.contains('cb-light');
            updateTickerTapeTheme(isLight);
        }
    }

    function _saveSettings(name, value) {
        const STORAGE_KEY = 'mainSettings';
        const EXPIRATION_TIME = typeof CACHE_EXPIRATION !== 'undefined' ? CACHE_EXPIRATION.PERSISTENT : 5256000;

        try {
            let payload = {};
            const existing = localStorage.getItem(STORAGE_KEY);
            if (existing) {
                payload = JSON.parse(existing)?.value;
            }
            payload[name] = value;
            settingsProps[name] = value;
            setCacheItem(STORAGE_KEY, payload, EXPIRATION_TIME);


        } catch (e) {
            console.warn('Failed to save main settings', e);
        }
    }
});
